module.exports = __webpack_public_path__ + "assets/img/code.227daf53.png";